import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { color: String, fadeOut: Boolean };

  connect() {
    this.highlightFromHash();
  }

  highlightFromHash() {
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        // Store original background classes
        const originalBgClasses = Array.from(element.classList).filter((cls) =>
          cls.startsWith("bg-")
        );

        // Add transition
        element.classList.add(
          "transition-colors",
          "duration-500",
          "ease-in-out"
        );

        // Remove existing background classes and add highlight
        originalBgClasses.forEach((cls) => element.classList.remove(cls));
        element.classList.add(this.colorValue);

        if (this.fadeOutValue) {
          setTimeout(() => {
            element.classList.remove(this.colorValue);
            // Restore original background classes
            originalBgClasses.forEach((cls) => element.classList.add(cls));
          }, 2500);
        }
      }
    }
  }
}
